<template>
  <div>

    <button type="button" id="button_modal_ventana_confirmacion" class="btn btn-primary d-none" data-toggle="modal" data-target="#ventana_confirmacion">
      Launch demo modal
    </button>

    <div class="modal fade" id="ventana_confirmacion" tabindex="-1" role="dialog" aria-labelledby="ventana_confirmacionLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ventana_confirmacionLabel">{{ $t("page.general.confirmacion") }}</h5>
            <button type="button" id="cerrar_modal_ventana_confirmacion" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                 {{$t(contenido)}}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">{{ $t("page.general.cancelar") }}</button>
            <button type="button" class="btn btn-success" v-on:click="SiProcesar">{{ $t("page.general.si") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props:[
    'contenido'
  ],
  data () {
    return {
    }
  },
  methods:{
    SiProcesar(){
      $('#cerrar_modal_ventana_confirmacion').click();
      this.$emit('SiProcesar');
    }
  },
  computed:{

  },
  created(){

  },
  updated(){

  },
  mounted(){

  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Herramientas/ventana_confirmacion.vue